var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChoosePhone = function SvgChoosePhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C8A5F4",
    fillRule: "evenodd",
    d: "M8.8 2.4A1.6 1.6 0 0 0 7.2 4v24a1.6 1.6 0 0 0 1.6 1.6h14.4a1.6 1.6 0 0 0 1.6-1.6V4a1.6 1.6 0 0 0-1.6-1.6zm13.6 4H9.6v19.2h12.8z",
    clipRule: "evenodd"
  })));
};
export default SvgChoosePhone;